// export const API_URL = 'http://127.0.0.1:8001/api/'
export const API_URL = 'https://api.eskrag.com/api/'
export const API_TIMEOUT = 100000